import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchFilterComponent } from '../search-filter/search-filter.component'

@Component({
    selector: 'lib-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [SearchFilterComponent]
})
export class SidebarComponent implements OnInit {

  @ViewChild(SearchFilterComponent) searchFilter: SearchFilterComponent;

  constructor() { }

  ngOnInit() {
  }

  resetTenantFilterToAll() {
    this.searchFilter.setTenantRadioButtonsToAll();
  }
}
